import {Box, IconButton, ListItemIcon, ListItemText, Menu, MenuItem} from "@mui/material";
import {useRouter} from "next/router";
import {useEffect, useState} from "react";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useApolloClient} from "@apollo/client";
import {
	faBars,
	faBuilding,
	faGear,
	faGridHorizontal,
	faMobile,
	faSignOut,
	faUser,
	faHome, faUserTie
} from "@fortawesome/pro-solid-svg-icons";
import {useTranslation} from "react-i18next";
import {useKeycloak} from "../../src/useKeycloak";
import useUserRole from "../../hooks/useUserRole";

const MainMenu = () => {
	const router = useRouter();
	const {t} = useTranslation();
	const client = useApolloClient();
	const {role, hasElevatedRights} = useUserRole();

	const [anchorEl, setAnchorEl] = useState(null);
	const [phoneApiHidden, setPhoneApiHidden] = useState(true);
	const [dashboardHidden, setDashboardHidden] = useState(true);

	const open = Boolean(anchorEl);
	const {tokenParsed, logout} = useKeycloak();

	useEffect(() => {
		setPhoneApiHidden(
			!tokenParsed.resource_access.youtello.roles.includes("operatorphonero") &&
			 !tokenParsed.resource_access.youtello.roles.includes("operatortelia")
		);

		setDashboardHidden(!tokenParsed.resource_access.youtello.roles.includes("operatordashboard"));
	}, [tokenParsed.resource_access.youtello.roles]);

	const handleClose = () => {
		setAnchorEl(null);
	};



	const menuItems = [
		{
			name: "Home",
			icon: <FontAwesomeIcon icon={faHome} size={"lg"} fixedWidth/>,
			link: "/entry",
			disabled: false
		},
		{
			name: "Profile",
			icon: <FontAwesomeIcon icon={faUser} size={"lg"} fixedWidth/>,
			link: "/profile",
			disabled: false
		},
		{
			name: "Organizations",
			icon: <FontAwesomeIcon icon={faBuilding} size={"lg"} fixedWidth/>,
			link: "/organizations",
			disabled: false
		},
		{
			name: "Phone API",
			icon: <FontAwesomeIcon icon={faMobile} size={"lg"} fixedWidth/>,
			link: "/phone-api",
			// disabled: disablePhoneAccess,
			visible: phoneApiHidden
		},
		{
			name: "Dashboard",
			icon: <FontAwesomeIcon icon={faGridHorizontal} size={"lg"} fixedWidth/>,
			link: "/dashboard",
			// disabled: hideDashboard
			visible: dashboardHidden
		},
		{
			name: "Settings",
			icon: <FontAwesomeIcon icon={faGear} size={"lg"} fixedWidth/>,
			link: "/settings"
		},
		{
			name: "Logout",
			icon: <FontAwesomeIcon icon={faSignOut} size={"lg"} fixedWidth/>
		}
	];
	return (
		<Box>
			<IconButton onClick={(e) => { setAnchorEl(e.currentTarget); }}
				sx={{}}
				aria-controls={open ? "account-menu" : undefined}
				aria-haspopup="true"
				aria-expanded={open ? "true" : undefined}
			>
				<FontAwesomeIcon icon={faBars}/>
			</IconButton>
			<Menu
				id="demo-positioned-menu"
				aria-labelledby="main-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right"
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "right"
				}}
			>
				{
					menuItems.map((item, index) => (
						!item.visible && <MenuItem
							key={index}
							sx={{ py: 1, px: 0}}
							disabled={item.disabled}
							onClick={() => {
								if (item.link !== undefined) {
									router.push(item.link);
								}
								else if (item.function !== undefined) {
									item.function();
								}
								else if (item.name === "Logout") {
									localStorage.removeItem("kc_token");
									localStorage.removeItem("kc_refreshToken");
									logout();
								}
								handleClose();
							}}
						>
							<ListItemIcon sx={{justifyContent: "center", pr: 1}}>
								{item.icon}
							</ListItemIcon>
							<ListItemText>
								{t(item.name)}
							</ListItemText>
						</MenuItem>
					))
				}

				{/* <MenuItem onClick={handleClose}>Profile</MenuItem>*/}
				{/* <MenuItem onClick={handleClose}>My account</MenuItem>*/}
				{/* <MenuItem onClick={handleClose}>Logout</MenuItem>*/}
			</Menu>
		</Box>
	);
};
export default MainMenu;
